import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";
import { buildURLForMenuItem } from "../../utils/buildURL";
import Link from "../../utils/Link";
import { LanguageContext, text } from "../../container/language";
import Paragraph from "../Article/Paragraph";
import { CategoryItems } from "../../templates/Category";

export const CategoryBlock = ({ data }) => {
  const { links = [], column2, column3 } = data;
  const { t } = useTranslation();
  const { userLanguage } = useContext(LanguageContext);
  // const items = data.items.map((item) => item.article || item.category);

  return (
    <CategoryItems
      body={[]}
      articleListType={data.articleListType}
      items={data.items}
      parentCategory={null}
      blockMode={true}
    />
  );
};
